var through = require('through2');

module.exports = function () {
  return through.obj();
};
